<template>
    <div class="full-screen-container" style="border: 1px solid #ccc">
        <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
        <Editor :style="{ height: Number(height) + 'px' }" v-model="html" :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" @onChange="onChange" />
        <div class="hideSource">
            <textarea v-model="html" :style="`height:${Number(height) + 'px'}`"></textarea>
        </div>
        <div class="editor-wang-count color999 fs12 t-r">
            <!-- 字数统计 -->
            {{ $t('web.word_count' /* 字数统计： */) }}{{ totalCount }}
            <!-- 单词量统计 -->
            <template v-if="lengthType == 2">{{ $t('web.word_count_limit' /* 单词统计： */) }}{{ wordTotalCount }} {{ maxLength ? '/' + maxLength : '' }}</template>
            <!-- 字数限制数量 -->
            <template v-else>{{ $t('web.word_count_limit_max' /* 字数限制： */) }}{{ maxLength ? '/' + maxLength : '' }}</template>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import editorConfig from './editorConfig.js';
import toolbarConfig from './toolbarConfig.js';
export default Vue.extend({
    components: { Editor, Toolbar },
    props: {
        mode: {
            type: String,
            default: 'default' //'simple' or 'default'
        },
        //内容
        value: {
            type: String
        },
        height: {
            type: [String, Number],
            default: '500px'
        },
        maxLength: {
            type: [Number, String],
            default: 0
        },
        // 1为字符数量限制 2为单词量限制
        lengthType: {
            type: [Number, String],
            default: 1
        }
    },
    data() {
        return {
            editor: null,
            html: '',
            toolbarConfig,
            editorConfig,
            totalCount: 0, // 总字符数量
            wordTotalCount: 0
        };
    },
    watch: {
        value: {
            handler(newVal) {
                this.html = newVal;
            },
            immediate: true
        }
    },
    methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
        },
        onChange(editor) {
            let text = this.editor.getText();
            let strCount = 0;
            // 字符数量
            let textStr = text?.replace(/\n|\r/gm, '');
            this.totalCount = textStr.length;

            if (this.lengthType == 1) {
                strCount = this.totalCount;
            }
            // 单词量数量判断
            if (this.lengthType == 2) {
                let textArr = text.split(' ');
                textArr = textArr.filter(function (s) {
                    return s && s.trim();
                });
                this.wordTotalCount = textArr.length;
                strCount = this.wordTotalCount;
            }

            if (this.maxLength && strCount > this.maxLength) {
                this.$message.error(this.$t('web.content_length_limit_max' /* 内容不能超过{maxLength}个字符 */), { maxLength: this.maxLength });
                return false;
            }
            this.$emit('change', this.html);
        }
    },
    mounted() {
        // 模拟 ajax 请求，异步渲染编辑器
        // setTimeout(() => {
        //     this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
        // }, 1500)
    },
    beforeDestroy() {
        const editor = this.editor;
        if (editor == null) return;
        editor.destroy(); // 组件销毁时，及时销毁编辑器
    }
});
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
.full-screen-container {
    z-index: 9999; /* 如有需要，可以自定义 z-index */
    position: relative;
}
.hideSource {
    width: 100%;
    display: none;
    textarea {
        width: 100%;
        border: none;
        padding: 20px 10px;
        box-sizing: border-box;
        &:focus {
            outline: none;
        }
    }
}
</style>
